import { type FC } from 'react';
import {
  CheckSquare
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCheckSquareProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCheckSquare: FC<UiIconCheckSquareProps> = (props) => {
  return (
    <UiIcon
      IconComponent={CheckSquare}
      {...props}
    />
  );
};
